module.exports = __webpack_public_path__ + "media/assets/images/pq1_old-8787e2c7b1cd3f18495cb628443f3364.svg";